import React from "react";
import Building from "../../../assets/images/Uni.svg";
import { useTranslation } from "react-i18next";
import Delete from "../../../assets/images/delete.svg";
import { addressFormat, amountFormat } from "../../../utils/WalletUtils";
import { WalletMA } from "boa-sdk-ts";

const BalanceSummary = (props) => {
  const { t } = useTranslation();
  const { senderListLoader, senderList, deleteSender } = props;
  const { selected_account } = WalletMA.instance().accounts;
  return (
    // Balance Summary Componentnp
    <div className="table-responsive one-table">
      <table className="table panelTable mt-30">
        <thead className="tableHead">
          <tr>
            <th>{t("Address")}</th>
            <th>{t("Drawn")}</th>
            <th>{t("Remaining")}</th>
            <th>{t("Spendable_Balance")}</th>
            <th>{t("Balance")}</th>
            <th>{t("Action")}</th>
          </tr>
        </thead>

        <tbody className="SenderTable">
          {senderList &&
            senderList.length > 0 &&
            senderList.map((info, index) => (
              <tr key={index}>
                <td>
                  <div className="align_left">
                    <img alt="Building" src={Building} />
                    <div className="purpleText tooltip1">
                      {addressFormat(info.account.address.toString())}
                      <div className="tooltiptext1">
                        <p>{info.account.address.toString()}</p>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="align_left">
                    <div className="fixed_value">
                      {amountFormat(info.drawn.toString())}
                    </div>{" "}
                    BOA{" "}
                  </div>
                </td>
                <td>
                  <div className="align_left">
                    <div
                      className={
                        info.remaining.toString() > 0
                          ? "redcolor fixed_value"
                          : "fixed_value"
                      }
                    >
                      {amountFormat(info.remaining.toString())}
                    </div>{" "}
                    BOA
                  </div>
                </td>
                <td>
                  <div className="align_left">
                    <div className="fixed_value">
                      {" "}
                      {amountFormat(info.spendable.toString())}
                    </div>
                    BOA
                  </div>
                </td>
                <td>
                  <div className="align_left">
                    <div className="fixed_value">
                      {amountFormat(info.account.balance.balance.toString())}
                    </div>{" "}
                    BOA
                  </div>
                </td>
                <td>
                  <div className="action-btn">
                    {selected_account &&
                    selected_account.address.toString() !==
                      info.account.address.toString() ? (
                      <button
                        onClick={() => {
                          deleteSender(info);
                        }}
                      >
                        <span className="clearIcon">
                          <img alt="CloseIcon" src={Delete} />
                        </span>
                      </button>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default BalanceSummary;
